/*
 * @Description:
 * @Autor: Dai YueLin
 * @Date: 2022-04-27 14:08:10
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-06-20 16:45:41
 */
/*
 * 判断字符串是否是Json数据格式
 * */
export function isJson(str: any) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}
/*
 * 判断链接地址是不是外链
 * */
export function isExternal(path: any) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

export function getUrlParam(name: any, str = window.location.search) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = str.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

export function getQueryString(name: any) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let r: RegExpMatchArray | null | string = '';
  if (window.location.search !== '') {
    r = window.location.search.substr(1).match(reg);
  } else {
    r = window.location.hash.substr(3).match(reg);
  }
  if (r != null) return unescape(r[2]);
  return null;
}

export function unique(arr: Array<any>, key: string) {
  const map = new Map();
  return arr.filter((item) => !map.has(item[key]) && item[key] && map.set(item[key], 1));
}

export function treeToArray(tree: any) {
  if (!tree) return [];
  return tree.reduce((res: any, item: any) => {
    const { children, ...i } = item;
    return res.concat(i, children && children.length ? treeToArray(children) : []);
  }, []);
}

export function formatFloat(num: any, n = 2) {
  let f = parseFloat(num);
  if (isNaN(f)) return '';
  f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // floor 舍 round 四舍五入 ceil 入
  const s = f.toString();
  // const rs = s.indexOf('.');
  // 判定如果是整数，增加小数点再补0
  // if (rs < 0) {
  //   rs = s.length;
  //   s += '.';
  // }
  // while (s.length <= rs + n) {
  //   s += '0';
  // }
  return s;
}

/**
 * 在不刷新的情况下，改变url hash参数，做到状态与url同步
 * 这是为了解决某些情况下状态变更，但页面history不记录的情况
 * 注意：如果使用此方法，请在页面监听hash参数，做到反向同步
 * @param state 新增参数
 * @param clear 是否删除原有参数
 * @param isRecord 是否记录进history队列
 */
export function changeUrlParams(state: any, clear = true, isRecord = true) {
  const queryString = location.hash.split('?')[1];
  let newQueryString = '',
    newState = {},
    fullUrl = '';
  if (state) {
    if (queryString && !clear) {
      // 处理旧的值
      queryString
        .trim()
        .split('&')
        .forEach((key: string) => (newState[key.split('=')[0]] = key.split('=')[1]));

      // 处理新的值，新的值与旧的值如果有冲突，会覆盖
      for (const key in state) {
        newState[key] = state[key];
      }
    } else {
      newState = state;
    }
    newQueryString = new URLSearchParams(newState).toString();
    fullUrl = location.origin + location.search + location.hash.split('?')[0] + '?' + newQueryString;
  } else {
    fullUrl = location.origin + location.search + location.hash.split('?')[0];
  }

  // const obj = {
  //   forward: null,
  //   position: 0,
  //   replaced: true,
  //   back: null,
  //   scroll: null,
  //   current: (location.hash.split('?')[0] + '?' + newQueryString).slice(1),
  // };

  // const obj = {}

  console.log(newState);

  if (isRecord) {
    history.pushState(newState, '', fullUrl);
  }

  // history.replaceState(newState, '', fullUrl);

  return fullUrl;
}
